// ----------------------------------------------------------------------------
//   Imports
// ----------------------------------------------------------------------------

// Material UI
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from "@mui/material";

// Custom Scripts
import { useScreenIsShort } from "../scripts/utils";


// ----------------------------------------------------------------------------
//   Main Component
// ----------------------------------------------------------------------------

function ScrollCard({ title, children, titleComponent = "h3", contentRef = null }) {

  // Check the height of the screen, for responsive layout
  const screenIsShort = useScreenIsShort();

  return (
    <Card h="100%">
      <CardContent sx={{ height: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column" }}>

        {/* Title */}
        <Typography
          component    = {titleComponent}
          variant      = "h6"
          fontWeight   = "bolder"
          marginBottom = { screenIsShort ? 1 : 2 }
          textAlign    = "center"
        >
          { title }
        </Typography>

        {/* Content */}
        <Box
          ref = { contentRef }
          position     = "relative"
          borderTop    = "1px solid rgba(0, 0, 0, 0.12)"
          borderBottom = "1px solid rgba(0, 0, 0, 0.12)"
          flexGrow = {1}
          marginX  = {1}
          padding  = {1}
          sx = {{ overflowY: "scroll", overflowX: "hidden" }}
        >
          { children }
        </Box>

      </CardContent>
    </Card>
  )
}


// ----------------------------------------------------------------------------
//   Export(s)
// ----------------------------------------------------------------------------

export default ScrollCard;
